<template>
  <div v-show="false">
    <!-- <Button @click="print">打印</Button> -->
    <div
      v-for="(data, i) in printData"
      :key="i"
      ref="container"
      style="padding: 10px 10px 0;box-sizing: border-box;width: 100%;height: 100%;"
    >
      <div ref="header"></div>
      <table
        class="data"
        ref="tabledata"
        style="border-collapse: collapse;width: 100%;min-height: 25px;line-height: 25px;padding: 2px;table-layout:fixed;text-align:center;"
      >
        <tr>
          <td
            v-for="field in fields"
            :key="field.key"
            v-bind="field.titleBind"
            style="border:1px solid #000;word-break: break-all;white-space: nowrap;"
            :style="{
              'text-overflow': field.overflow ? 'ellipsis' : '',
              overflow: field.overflow ? 'hidden' : ''
            }"
          >
            {{ $t(isMethod(field.name)) }}
          </td>
        </tr>
        <tbody v-for="(row, rowIndex) in data" :key="rowIndex">
          <tr v-for="(col, colIndex) in row" :key="colIndex">
            <td
              v-for="(field, fieldIndex) in fields"
              :key="field.key"
              v-bind="field.bind"
              :rowspan="fieldIndex === 0 ? row.length : ''"
              v-if="col.$top || fieldIndex !== 0"
              style="border:1px solid #000;word-break: break-all;white-space: nowrap;"
              :style="{
                'text-overflow': field.overflow ? 'ellipsis' : '',
                overflow: field.overflow ? 'hidden' : ''
              }"
            >
              {{ $t(col[field.key]) }}
            </td>
          </tr>
        </tbody>
      </table>
      <div ref="footer"></div>
    </div>
  </div>
</template>

<script>
import getLodop from "@/utils/lodop";
export default {
  data() {
    return {
      size: 20,
      fields: [],
      tabledata: {}
    };
  },
  computed: {
    printData() {
      return this.splitData.map(item => {
        return item.map(child => {
          if (Array.isArray(child)) {
            if (child[0]) child[0].$top = true;
            return child;
          } else {
            child.$top = true;
            return [child];
          }
        });
      });
    },
    splitData() {
      let Lens = [0];
      let copyData = JSON.parse(JSON.stringify(this.tabledata));
      return Object.keys(this.tabledata).reduce(
        (a, b) => {
          if (Lens[a.length - 1] > this.size)
            a.push([]), (Lens[a.length - 1] = 0);
          let dataLen = Array.isArray(this.tabledata[b])
            ? this.tabledata[b].length
            : 1;
          if (Lens[a.length - 1] + dataLen > this.size) {
            let num = Lens[a.length - 1] + dataLen - this.size;
            a[a.length - 1].push(copyData[b].splice(0, dataLen - num));
            a.push([copyData[b]]), (Lens[a.length - 1] = num);
          } else {
            Lens[a.length - 1] += dataLen;
            a[a.length - 1].push(this.tabledata[b]);
          }
          return a;
        },
        [[]]
      );
    }
  },
  methods: {
    start({ fields, headerRender, footerRender, config = {}, data }) {
      this.tabledata = data || {};
      console.log(this.tabledata, this.fields);
      this.size = config.size || this.size;
      this.$nextTick(() => {
        this.fields = fields;
        this.config = config;
        let headerEls = this.$refs["header"];
        let footerEls = this.$refs["footer"];
        let el = [
          [headerEls, headerRender],
          [footerEls, footerRender]
        ];
        el.forEach(t => {
          t[0].forEach((el, index) => {
            el.innerHTML = this.isMethodDefault(
              t[1],
              {
                list: this.printData[index],
                allList: this.printData,
                fields,
                index
              },
              ""
            );
          });
        });
        this.$nextTick(() => this.print());
      });
    },
    isMethod(methods, params) {
      if (typeof methods === "function") return methods.call(this, params);
      return methods;
    },
    isMethodDefault(methods, params, df) {
      if (typeof methods === "function") return methods.call(this, params);
      return df;
    },
    print() {
      let lodop = getLodop(this);
      LODOP.PRINT_INIT("打印任务名"); //首先一个初始化语句
      LODOP.SET_PRINT_PAGESIZE(1, "210mm", "297mm", ""); //规定纸张大小；使用A4纸
      LODOP.SET_PRINT_STYLEA(0, "ItemType", 1); //ItemType:设置上面的为页眉页脚，每页固定位置输出
      this.printData.forEach((item, index) => {
        LODOP.ADD_PRINT_HTML(
          0,
          0,
          "RightMargin:0mm",
          "BottomMargin:0mm",
          this.$refs["container"][index].outerHTML
        );
        LODOP.NEWPAGE();
      });
      LODOP.PREVIEW(); //打印预览
    }
  }
};
</script>

<style lang="less" scoped>
.border {
  border: 1px solid;
}
.center {
  text-align: center;
}
</style>
